<template>
  <el-dialog title="新词导入" :visible.sync="dialogVisiImport" width="50%" :before-close="handleClose"
    :close-on-click-modal="false" >
    <div class="container_row" v-loading="diaLoading">
      <span>请选择文件：</span>
      <el-upload class="upload-demo" :action="sendUrl" ref="uploadRef" :headers="headers" :multiple="false"
        :auto-upload="false" :before-upload="beforeUpload" :on-error="onError" :on-success="handleSuccess"
        accept=".xls,.xlsx,.csv" :on-remove="onRemove" :on-change="handleChange" :file-list="fileList">
        <el-button size="small" type="primary">请选择 Excel 文件</el-button>
        <div slot="tip" class="el-upload__tip">只能上传.xls/.xlsx/.csv格式文件，且不超过20M</div>
      </el-upload>
      <span @click="downLoadTemplate()">下载导入模板</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose(false)" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small" :loading="diaLoading">{{ diaLoading? '导入中': '导入' }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
// import { importData, getTwoClass, getOneClass, deleteScript } from "@/api/sciptLibrary/index";
import {importData} from '@/api/keyWords/index'
export default {
  props: {
    dialogVisiImport: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      headers: {
        authorization: '',
      },
      sendUrl: this.$baseUrl + '/api/chatMaterial/uploadFile',
      fileList: [],
      diaLoading: false,
      needLoadingRequestCount: 0,
    };
  }, created() {
    this.headers.authorization = localStorage.getItem("Authorization");
  },
  methods: {
    downLoadTemplate() {
      this.download('/api/sensitive/consult/exportExcel', `新词库模板_${new Date().getTime()}.xlsx`, {}, localStorage.getItem("Authorization"), '', 'get')
    },
    // 上传之前
    beforeUpload(file) {
      const nameArr = file.name.split('.')
      const type = nameArr[nameArr.length - 1]
      console.log('beforeUpload', file, type);
      const isLt2M = file.size / 1024 / 1024 < 20 // 限制大小
      if (['xls', 'xlsx', 'csv'].indexOf(type) == -1) {
        this.$message.error('上传文件只能是 .xls,.xlsx,.csv 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 20MB!')
        return false
      }
      this.showLoading()
      return true
    },

    //显示loading
    showLoading() {
      // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
      // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
      if (this.needLoadingRequestCount === 0 && !this.loading) {
        this.loading = this.$loading({
          lock: true,
          text: '拼命上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      this.needLoadingRequestCount++;
    },
    //隐藏loading
    hideLoading() {
      // if(this.needLoadingRequestCount <= 0) return
      this.needLoadingRequestCount--
      if (this.needLoadingRequestCount === 0) {
        this.loading.close();
        this.loading = null;
      }
    },
    handleChange(file, fileList) {
      console.log(456, file, fileList);
      this.fileList = []
      const oneArr = [
        file
      ]
      this.fileList = oneArr



    },

    handleSuccess(res, file, fileList) {
      console.log('res', res)
      // if(res.error.code == 200) {
      //   this.type = 0
      //   this.photoList.push(res.data)
      // }else {
      //   this.$message({
      //     message: res.error.message,
      //     type: 'info',
      //     offset: 30,
      //     customClass: 'info-message',
      //     duration: 4000
      //   })
      //   // this.$refs.uploadVideoItem.uploadFiles.splice(this.$refs.uploadVideoItem.uploadFiles.length-1,1)
      // }
      setTimeout(() => {
        this.hideLoading()
      }, 200)

    },
    onError() {

      setTimeout(() => {
        this.hideLoading()
      }, 200);
      this.$message.error('上传失败，请重试！')
    },

    onRemove() {
      this.fileList = []
    },

    async submit() {
      if (this.fileList.length == 0) {
        return this.$message({
          type: 'warning',
          message: '导入文件不能为空'
        })
      }
      this.diaLoading = true

      let formData = new FormData()
      this.fileList.forEach(file => {
        //所有文件保存在formData中
        formData.append('file', file.raw)
      })

      // try {
        const res = await importData(formData, localStorage.getItem("Authorization"))
      // } catch (error) {

      // }


      this.diaLoading = false
      let type = ""
      if (res.error.code == 200) {
        type = "success"
      } else {
        type = "warning"
      }

      this.$confirm(res.data, '导入结果', {
        confirmButtonText: '关闭',
        showCancelButton: false,
        type: type
      }).then(() => {

        if (type == "success") {
          this.handleClose(true)
        } else {

          this.fileList = []
        }
        this.fileList = []
      }).catch(() => {
        
      });
    },


    handleClose(types = false) {
      this.$emit("dialogVisiImport", types)
      this.$emit('getData')
    },

  },
};
</script>
<style lang="scss" scoped>
.container_row {
  display: flex;
  justify-content: flex-start;

  // align-items: center;
  span {
    &:not(:first-child) {
      margin-left: 10px;
      cursor: pointer;
    }

    &:nth-child(1) {}

    &:nth-child(3) {
      color: #409eff;
      text-decoration: underline;
      margin-left: 150px;
    }
  }

  .upload-demo {
    // padding: 5px 8px;
    // background-color: #409eff;
    // color: #ffff;
    // border-radius: 5px;
    position: relative;

    .el-upload__tip {
      position: absolute !important;
      width: 230%;
    }

    /deep/.el-upload-list {
      margin-top: 35px;
    }
  }
}
</style>